/** Monta o preâmbulo da impugnação a partir de ConfiguracaoEmpresa (Empresas → Dados da Empresa). */

function onlyDigits(s) {
  return String(s ?? '').replace(/\D/g, '');
}

function trimOrEmpty(v) {
  if (v == null) return '';
  const t = String(v).trim();
  return t;
}

export function formatCnpjApresentacao(raw) {
  const d = onlyDigits(raw);
  if (d.length !== 14) return trimOrEmpty(raw) || '';
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12, 14)}`;
}

export function formatCpfApresentacao(raw) {
  const d = onlyDigits(raw);
  if (d.length !== 11) return trimOrEmpty(raw) || '';
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9, 11)}`;
}

/**
 * @param {Record<string, unknown>|null|undefined} cfg — registro de configuracao-empresa (snake_case ou camelCase)
 * @returns {string} Parágrafo único de qualificação; string vazia se não houver cfg
 */
export function buildQualificacaoImpugnanteParagrafo(cfg) {
  if (!cfg || typeof cfg !== 'object') return '';

  const razao =
    trimOrEmpty(cfg.razao_social ?? cfg.razaoSocial) ||
    '[NOME COMPLETO DO IMPUGNANTE/RAZÃO SOCIAL DA EMPRESA, A CONFIRMAR]';

  const cnpjFmt = formatCnpjApresentacao(cfg.cnpj);
  const cnpjTxt = cnpjFmt || '[A CONFIRMAR]';

  const endereco =
    trimOrEmpty(cfg.endereco_completo ?? cfg.enderecoCompleto) || '[ENDEREÇO COMPLETO, A CONFIRMAR]';

  const cargo =
    trimOrEmpty(cfg.socio_cargo ?? cfg.socioCargo) || '[CARGO DO REPRESENTANTE LEGAL, A CONFIRMAR]';

  const nomeRep =
    trimOrEmpty(cfg.socio_nome ?? cfg.socioNome) ||
    trimOrEmpty(cfg.resp_contrato_nome ?? cfg.respContratoNome) ||
    '[NOME DO REPRESENTANTE LEGAL, A CONFIRMAR]';

  const rg = trimOrEmpty(cfg.resp_contrato_rg ?? cfg.respContratoRg) || '[A CONFIRMAR]';

  const cpfFmt = formatCpfApresentacao(cfg.resp_contrato_cpf ?? cfg.respContratoCpf);
  const cpfTxt = cpfFmt || '[A CONFIRMAR]';

  return `${razao}, pessoa jurídica de direito privado, inscrita no CNPJ sob o nº ${cnpjTxt}, com sede em ${endereco}, neste ato representada por seu(sua) ${cargo}, ${nomeRep}, portador(a) do RG nº ${rg} e CPF nº ${cpfTxt}, por seu advogado infra-assinado (procuração anexa), vem, respeitosamente, perante Vossa Senhoria, com base na Lei nº [14.133/2021 ou 8.666/1993, conforme indicado no instrumento convocatório], apresentar:

IMPUGNAÇÃO AO EDITAL

contra os termos do edital da licitação epigrafada, pelos motivos de fato e direito a seguir expostos:`;
}

/**
 * Ordem forense: cabeçalho extraído do edital (IA) → qualificação do impugnante (cadastro) → corpo (IA).
 * Omite partes vazias após trim.
 * @param {string} cabecalhoInstitucional
 * @param {string} qualificacao
 * @param {string} corpo
 * @returns {string}
 */
export function montarMinutaImpugnacaoCompleta(cabecalhoInstitucional, qualificacao, corpo) {
  const parts = [cabecalhoInstitucional, qualificacao, corpo].map((s) => String(s ?? '').trim()).filter(Boolean);
  return parts.join('\n\n');
}

/**
 * @param {string} qualificacao
 * @param {string} corpo
 * @returns {string}
 */
export function juntarQualificacaoECorpoMinuta(qualificacao, corpo) {
  const q = String(qualificacao || '').trim();
  const c = String(corpo || '').trim();
  if (q && c) return `${q}\n\n${c}`;
  if (q) return q;
  return c;
}
